import {AxiosInstance} from "axios";
import {HealthJourneyProposal, HealthJourneyProposalRequest} from "@/agenda/interfaces/healthJourney";

/**
 * The planning server's health journey proposals.
 *
 * Reading only: the server lays acts out on the agenda and says why, and the
 * appointments themselves are written afterwards, on the health server, from
 * what the pharmacist kept.
 */
const HealthJourneyResource = (apiClient: AxiosInstance) => {
    return {
        /**
         * Lay a series of acts out on the agenda.
         *
         * @param organizationId
         * @param assistantKey
         * @param request
         */
        async propose(
            organizationId: number,
            assistantKey: string,
            request: HealthJourneyProposalRequest
        ): Promise<HealthJourneyProposal> {
            const response = await apiClient.post(
                `organizations/${organizationId}/ai-assistants/${assistantKey}/health-journey-proposals`,
                {data: request}
            );

            return response.data.data;
        }
    };
};

export default HealthJourneyResource;
